export default __webpack_public_path__ + "static/media/overview_icon_3.134954bb.png";